import { connect } from 'react-redux';
import { BrowseComponent } from './browse.component';

const mapStateToProps = (state: any) => ({});

const mapDispatchToProps = (dispatch: any) => ({}); 

export const BrowseContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(BrowseComponent);